import type { BillSwitchEventPayload } from '@pinwheel/react-modal';

export const computeBillsTotal = (switches: BillSwitchEventPayload[]) => {
  const nextMonthSwitchesTotal = switches.reduce(
    (acc, billSwitch) => acc + billSwitch.amountCents,
    0,
  );

  const inDollars = nextMonthSwitchesTotal / 100; // convert cents to dollars

  if (isNaN(inDollars) || !isFinite(inDollars) || inDollars <= 0) {
    return undefined;
  }

  return inDollars.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
